export default {
  '1': {
    'size'  : 249250621,
    'bands' : [
      { 'id': 'p11.1',  'start': 121500001, 'end': 125000000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 120600001, 'end': 121500000, 'type': 'gneg'    },
      { 'id': 'p12',    'start': 117800001, 'end': 120600000, 'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 116100001, 'end': 117800000, 'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 111800001, 'end': 116100000, 'type': 'gpos50'  },
      { 'id': 'p13.3',  'start': 107200001, 'end': 111800000, 'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 102200001, 'end': 107200000, 'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 99700001,  'end': 102200000, 'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 94700001,  'end': 99700000,  'type': 'gpos75'  },
      { 'id': 'p22.1',  'start': 92000001,  'end': 94700000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 88400001,  'end': 92000000,  'type': 'gpos75'  },
      { 'id': 'p22.3',  'start': 84900001,  'end': 88400000,  'type': 'gneg'    },
      { 'id': 'p31.1',  'start': 69700001,  'end': 84900000,  'type': 'gpos100' },
      { 'id': 'p31.2',  'start': 68900001,  'end': 69700000,  'type': 'gneg'    },
      { 'id': 'p31.3',  'start': 61300001,  'end': 68900000,  'type': 'gpos50'  },
      { 'id': 'p32.1',  'start': 59000001,  'end': 61300000,  'type': 'gneg'    },
      { 'id': 'p32.2',  'start': 56100001,  'end': 59000000,  'type': 'gpos50'  },
      { 'id': 'p32.3',  'start': 50700001,  'end': 56100000,  'type': 'gneg'    },
      { 'id': 'p33',    'start': 46800001,  'end': 50700000,  'type': 'gpos75'  },
      { 'id': 'p34.1',  'start': 44100001,  'end': 46800000,  'type': 'gneg'    },
      { 'id': 'p34.2',  'start': 40100001,  'end': 44100000,  'type': 'gpos25'  },
      { 'id': 'p34.3',  'start': 34600001,  'end': 40100000,  'type': 'gneg'    },
      { 'id': 'p35.1',  'start': 32400001,  'end': 34600000,  'type': 'gpos25'  },
      { 'id': 'p35.2',  'start': 30200001,  'end': 32400000,  'type': 'gneg'    },
      { 'id': 'p35.3',  'start': 28000001,  'end': 30200000,  'type': 'gpos25'  },
      { 'id': 'p36.11', 'start': 23900001,  'end': 28000000,  'type': 'gneg'    },
      { 'id': 'p36.12', 'start': 20400001,  'end': 23900000,  'type': 'gpos25'  },
      { 'id': 'p36.13', 'start': 16200001,  'end': 20400000,  'type': 'gneg'    },
      { 'id': 'p36.21', 'start': 12700001,  'end': 16200000,  'type': 'gpos50'  },
      { 'id': 'p36.22', 'start': 9200001,   'end': 12700000,  'type': 'gneg'    },
      { 'id': 'p36.23', 'start': 7200001,   'end': 9200000,   'type': 'gpos25'  },
      { 'id': 'p36.31', 'start': 5400001,   'end': 7200000,   'type': 'gneg'    },
      { 'id': 'p36.32', 'start': 2300001,   'end': 5400000,   'type': 'gpos25'  },
      { 'id': 'p36.33', 'start': 1,         'end': 2300000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 125000001, 'end': 128900000, 'type': 'acen'    },
      { 'id': 'q12',    'start': 128900001, 'end': 142600000, 'type': 'gvar'    },
      { 'id': 'q21.1',  'start': 142600001, 'end': 147000000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 147000001, 'end': 150300000, 'type': 'gpos50'  },
      { 'id': 'q21.3',  'start': 150300001, 'end': 155000000, 'type': 'gneg'    },
      { 'id': 'q22',    'start': 155000001, 'end': 156500000, 'type': 'gpos50'  },
      { 'id': 'q23.1',  'start': 156500001, 'end': 159100000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 159100001, 'end': 160500000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 160500001, 'end': 165500000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 165500001, 'end': 167200000, 'type': 'gpos50'  },
      { 'id': 'q24.2',  'start': 167200001, 'end': 170900000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 170900001, 'end': 172900000, 'type': 'gpos75'  },
      { 'id': 'q25.1',  'start': 172900001, 'end': 176000000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 176000001, 'end': 180300000, 'type': 'gpos50'  },
      { 'id': 'q25.3',  'start': 180300001, 'end': 185800000, 'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 185800001, 'end': 190800000, 'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 190800001, 'end': 193800000, 'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 193800001, 'end': 198700000, 'type': 'gpos100' },
      { 'id': 'q32.1',  'start': 198700001, 'end': 207200000, 'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 207200001, 'end': 211500000, 'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 211500001, 'end': 214500000, 'type': 'gneg'    },
      { 'id': 'q41',    'start': 214500001, 'end': 224100000, 'type': 'gpos100' },
      { 'id': 'q42.11', 'start': 224100001, 'end': 224600000, 'type': 'gneg'    },
      { 'id': 'q42.12', 'start': 224600001, 'end': 227000000, 'type': 'gpos25'  },
      { 'id': 'q42.13', 'start': 227000001, 'end': 230700000, 'type': 'gneg'    },
      { 'id': 'q42.2',  'start': 230700001, 'end': 234700000, 'type': 'gpos50'  },
      { 'id': 'q42.3',  'start': 234700001, 'end': 236600000, 'type': 'gneg'    },
      { 'id': 'q43',    'start': 236600001, 'end': 243700000, 'type': 'gpos75'  },
      { 'id': 'q44',    'start': 243700001, 'end': 249250621, 'type': 'gneg'    },
    ],
  },
  '2': {
    'size'  : 243199373,
    'bands' : [
      { 'id': 'p11.1', 'start': 90500001,  'end': 93300000,  'type': 'acen'    },
      { 'id': 'p11.2', 'start': 83300001,  'end': 90500000,  'type': 'gneg'    },
      { 'id': 'p12',   'start': 75000001,  'end': 83300000,  'type': 'gpos100' },
      { 'id': 'p13.1', 'start': 73500001,  'end': 75000000,  'type': 'gneg'    },
      { 'id': 'p13.2', 'start': 71500001,  'end': 73500000,  'type': 'gpos50'  },
      { 'id': 'p13.3', 'start': 68600001,  'end': 71500000,  'type': 'gneg'    },
      { 'id': 'p14',   'start': 64100001,  'end': 68600000,  'type': 'gpos50'  },
      { 'id': 'p15',   'start': 61300001,  'end': 64100000,  'type': 'gneg'    },
      { 'id': 'p16.1', 'start': 55000001,  'end': 61300000,  'type': 'gpos100' },
      { 'id': 'p16.2', 'start': 52900001,  'end': 55000000,  'type': 'gneg'    },
      { 'id': 'p16.3', 'start': 47800001,  'end': 52900000,  'type': 'gpos100' },
      { 'id': 'p21',   'start': 41800001,  'end': 47800000,  'type': 'gneg'    },
      { 'id': 'p22.1', 'start': 38600001,  'end': 41800000,  'type': 'gpos50'  },
      { 'id': 'p22.2', 'start': 36600001,  'end': 38600000,  'type': 'gneg'    },
      { 'id': 'p22.3', 'start': 32100001,  'end': 36600000,  'type': 'gpos75'  },
      { 'id': 'p23.1', 'start': 30000001,  'end': 32100000,  'type': 'gneg'    },
      { 'id': 'p23.2', 'start': 27900001,  'end': 30000000,  'type': 'gpos25'  },
      { 'id': 'p23.3', 'start': 24000001,  'end': 27900000,  'type': 'gneg'    },
      { 'id': 'p24.1', 'start': 19200001,  'end': 24000000,  'type': 'gpos75'  },
      { 'id': 'p24.2', 'start': 16700001,  'end': 19200000,  'type': 'gneg'    },
      { 'id': 'p24.3', 'start': 12200001,  'end': 16700000,  'type': 'gpos75'  },
      { 'id': 'p25.1', 'start': 7100001,   'end': 12200000,  'type': 'gneg'    },
      { 'id': 'p25.2', 'start': 4400001,   'end': 7100000,   'type': 'gpos50'  },
      { 'id': 'p25.3', 'start': 1,         'end': 4400000,   'type': 'gneg'    },
      { 'id': 'q11.1', 'start': 93300001,  'end': 96800000,  'type': 'acen'    },
      { 'id': 'q11.2', 'start': 96800001,  'end': 102700000, 'type': 'gneg'    },
      { 'id': 'q12.1', 'start': 102700001, 'end': 106000000, 'type': 'gpos50'  },
      { 'id': 'q12.2', 'start': 106000001, 'end': 107500000, 'type': 'gneg'    },
      { 'id': 'q12.3', 'start': 107500001, 'end': 110200000, 'type': 'gpos25'  },
      { 'id': 'q13',   'start': 110200001, 'end': 114400000, 'type': 'gneg'    },
      { 'id': 'q14.1', 'start': 114400001, 'end': 118800000, 'type': 'gpos50'  },
      { 'id': 'q14.2', 'start': 118800001, 'end': 122400000, 'type': 'gneg'    },
      { 'id': 'q14.3', 'start': 122400001, 'end': 129900000, 'type': 'gpos50'  },
      { 'id': 'q21.1', 'start': 129900001, 'end': 132500000, 'type': 'gneg'    },
      { 'id': 'q21.2', 'start': 132500001, 'end': 135100000, 'type': 'gpos25'  },
      { 'id': 'q21.3', 'start': 135100001, 'end': 136800000, 'type': 'gneg'    },
      { 'id': 'q22.1', 'start': 136800001, 'end': 142200000, 'type': 'gpos100' },
      { 'id': 'q22.2', 'start': 142200001, 'end': 144100000, 'type': 'gneg'    },
      { 'id': 'q22.3', 'start': 144100001, 'end': 148700000, 'type': 'gpos100' },
      { 'id': 'q23.1', 'start': 148700001, 'end': 149900000, 'type': 'gneg'    },
      { 'id': 'q23.2', 'start': 149900001, 'end': 150500000, 'type': 'gpos25'  },
      { 'id': 'q23.3', 'start': 150500001, 'end': 154900000, 'type': 'gneg'    },
      { 'id': 'q24.1', 'start': 154900001, 'end': 159800000, 'type': 'gpos75'  },
      { 'id': 'q24.2', 'start': 159800001, 'end': 163700000, 'type': 'gneg'    },
      { 'id': 'q24.3', 'start': 163700001, 'end': 169700000, 'type': 'gpos75'  },
      { 'id': 'q31.1', 'start': 169700001, 'end': 178000000, 'type': 'gneg'    },
      { 'id': 'q31.2', 'start': 178000001, 'end': 180600000, 'type': 'gpos50'  },
      { 'id': 'q31.3', 'start': 180600001, 'end': 183000000, 'type': 'gneg'    },
      { 'id': 'q32.1', 'start': 183000001, 'end': 189400000, 'type': 'gpos75'  },
      { 'id': 'q32.2', 'start': 189400001, 'end': 191900000, 'type': 'gneg'    },
      { 'id': 'q32.3', 'start': 191900001, 'end': 197400000, 'type': 'gpos75'  },
      { 'id': 'q33.1', 'start': 197400001, 'end': 203300000, 'type': 'gneg'    },
      { 'id': 'q33.2', 'start': 203300001, 'end': 204900000, 'type': 'gpos50'  },
      { 'id': 'q33.3', 'start': 204900001, 'end': 209000000, 'type': 'gneg'    },
      { 'id': 'q34',   'start': 209000001, 'end': 215300000, 'type': 'gpos100' },
      { 'id': 'q35',   'start': 215300001, 'end': 221500000, 'type': 'gneg'    },
      { 'id': 'q36.1', 'start': 221500001, 'end': 225200000, 'type': 'gpos75'  },
      { 'id': 'q36.2', 'start': 225200001, 'end': 226100000, 'type': 'gneg'    },
      { 'id': 'q36.3', 'start': 226100001, 'end': 231000000, 'type': 'gpos100' },
      { 'id': 'q37.1', 'start': 231000001, 'end': 235600000, 'type': 'gneg'    },
      { 'id': 'q37.2', 'start': 235600001, 'end': 237300000, 'type': 'gpos50'  },
      { 'id': 'q37.3', 'start': 237300001, 'end': 243199373, 'type': 'gneg'    },
    ],
  },
  '3': {
    'size'  : 198022430,
    'bands' : [
      { 'id': 'p11.1',  'start': 87900001,  'end': 91000000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 87200001,  'end': 87900000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 83500001,  'end': 87200000,  'type': 'gpos75'  },
      { 'id': 'p12.2',  'start': 79800001,  'end': 83500000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 74200001,  'end': 79800000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 69800001,  'end': 74200000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 63700001,  'end': 69800000,  'type': 'gpos50'  },
      { 'id': 'p14.2',  'start': 58600001,  'end': 63700000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 54400001,  'end': 58600000,  'type': 'gpos50'  },
      { 'id': 'p21.1',  'start': 52300001,  'end': 54400000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 50600001,  'end': 52300000,  'type': 'gpos25'  },
      { 'id': 'p21.31', 'start': 44200001,  'end': 50600000,  'type': 'gneg'    },
      { 'id': 'p21.32', 'start': 44100001,  'end': 44200000,  'type': 'gpos50'  },
      { 'id': 'p21.33', 'start': 43700001,  'end': 44100000,  'type': 'gneg'    },
      { 'id': 'p22.1',  'start': 39400001,  'end': 43700000,  'type': 'gpos75'  },
      { 'id': 'p22.2',  'start': 36500001,  'end': 39400000,  'type': 'gneg'    },
      { 'id': 'p22.3',  'start': 32100001,  'end': 36500000,  'type': 'gpos50'  },
      { 'id': 'p23',    'start': 30900001,  'end': 32100000,  'type': 'gneg'    },
      { 'id': 'p24.1',  'start': 26400001,  'end': 30900000,  'type': 'gpos75'  },
      { 'id': 'p24.2',  'start': 23900001,  'end': 26400000,  'type': 'gneg'    },
      { 'id': 'p24.3',  'start': 16400001,  'end': 23900000,  'type': 'gpos100' },
      { 'id': 'p25.1',  'start': 13300001,  'end': 16400000,  'type': 'gneg'    },
      { 'id': 'p25.2',  'start': 11800001,  'end': 13300000,  'type': 'gpos25'  },
      { 'id': 'p25.3',  'start': 8700001,   'end': 11800000,  'type': 'gneg'    },
      { 'id': 'p26.1',  'start': 4000001,   'end': 8700000,   'type': 'gpos50'  },
      { 'id': 'p26.2',  'start': 2800001,   'end': 4000000,   'type': 'gneg'    },
      { 'id': 'p26.3',  'start': 1,         'end': 2800000,   'type': 'gpos50'  },
      { 'id': 'q11.1',  'start': 91000001,  'end': 93900000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 93900001,  'end': 98300000,  'type': 'gvar'    },
      { 'id': 'q12.1',  'start': 98300001,  'end': 100000000, 'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 100000001, 'end': 100900000, 'type': 'gpos25'  },
      { 'id': 'q12.3',  'start': 100900001, 'end': 102800000, 'type': 'gneg'    },
      { 'id': 'q13.11', 'start': 102800001, 'end': 106200000, 'type': 'gpos75'  },
      { 'id': 'q13.12', 'start': 106200001, 'end': 107900000, 'type': 'gneg'    },
      { 'id': 'q13.13', 'start': 107900001, 'end': 111300000, 'type': 'gpos50'  },
      { 'id': 'q13.2',  'start': 111300001, 'end': 113500000, 'type': 'gneg'    },
      { 'id': 'q13.31', 'start': 113500001, 'end': 117300000, 'type': 'gpos75'  },
      { 'id': 'q13.32', 'start': 117300001, 'end': 119000000, 'type': 'gneg'    },
      { 'id': 'q13.33', 'start': 119000001, 'end': 121900000, 'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 121900001, 'end': 123800000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 123800001, 'end': 125800000, 'type': 'gpos25'  },
      { 'id': 'q21.3',  'start': 125800001, 'end': 129200000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 129200001, 'end': 133700000, 'type': 'gpos25'  },
      { 'id': 'q22.2',  'start': 133700001, 'end': 135700000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 135700001, 'end': 138700000, 'type': 'gpos25'  },
      { 'id': 'q23',    'start': 138700001, 'end': 142800000, 'type': 'gneg'    },
      { 'id': 'q24',    'start': 142800001, 'end': 148900000, 'type': 'gpos100' },
      { 'id': 'q25.1',  'start': 148900001, 'end': 152100000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 152100001, 'end': 155000000, 'type': 'gpos50'  },
      { 'id': 'q25.31', 'start': 155000001, 'end': 157000000, 'type': 'gneg'    },
      { 'id': 'q25.32', 'start': 157000001, 'end': 159000000, 'type': 'gpos50'  },
      { 'id': 'q25.33', 'start': 159000001, 'end': 160700000, 'type': 'gneg'    },
      { 'id': 'q26.1',  'start': 160700001, 'end': 167600000, 'type': 'gpos100' },
      { 'id': 'q26.2',  'start': 167600001, 'end': 170900000, 'type': 'gneg'    },
      { 'id': 'q26.31', 'start': 170900001, 'end': 175700000, 'type': 'gpos75'  },
      { 'id': 'q26.32', 'start': 175700001, 'end': 179000000, 'type': 'gneg'    },
      { 'id': 'q26.33', 'start': 179000001, 'end': 182700000, 'type': 'gpos75'  },
      { 'id': 'q27.1',  'start': 182700001, 'end': 184500000, 'type': 'gneg'    },
      { 'id': 'q27.2',  'start': 184500001, 'end': 186000000, 'type': 'gpos25'  },
      { 'id': 'q27.3',  'start': 186000001, 'end': 187900000, 'type': 'gneg'    },
      { 'id': 'q28',    'start': 187900001, 'end': 192300000, 'type': 'gpos75'  },
      { 'id': 'q29',    'start': 192300001, 'end': 198022430, 'type': 'gneg'    },
    ],
  },
  '4': {
    'size'  : 191154276,
    'bands' : [
      { 'id': 'p11',    'start': 48200001,  'end': 50400000,  'type': 'acen'    },
      { 'id': 'p12',    'start': 44600001,  'end': 48200000,  'type': 'gneg'    },
      { 'id': 'p13',    'start': 41200001,  'end': 44600000,  'type': 'gpos50'  },
      { 'id': 'p14',    'start': 35800001,  'end': 41200000,  'type': 'gneg'    },
      { 'id': 'p15.1',  'start': 27700001,  'end': 35800000,  'type': 'gpos100' },
      { 'id': 'p15.2',  'start': 21300001,  'end': 27700000,  'type': 'gneg'    },
      { 'id': 'p15.31', 'start': 17800001,  'end': 21300000,  'type': 'gpos75'  },
      { 'id': 'p15.32', 'start': 15200001,  'end': 17800000,  'type': 'gneg'    },
      { 'id': 'p15.33', 'start': 11300001,  'end': 15200000,  'type': 'gpos50'  },
      { 'id': 'p16.1',  'start': 6000001,   'end': 11300000,  'type': 'gneg'    },
      { 'id': 'p16.2',  'start': 4500001,   'end': 6000000,   'type': 'gpos25'  },
      { 'id': 'p16.3',  'start': 1,         'end': 4500000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 50400001,  'end': 52700000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 52700001,  'end': 59500000,  'type': 'gneg'    },
      { 'id': 'q13.1',  'start': 59500001,  'end': 66600000,  'type': 'gpos100' },
      { 'id': 'q13.2',  'start': 66600001,  'end': 70500000,  'type': 'gneg'    },
      { 'id': 'q13.3',  'start': 70500001,  'end': 76300000,  'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 76300001,  'end': 78900000,  'type': 'gneg'    },
      { 'id': 'q21.21', 'start': 78900001,  'end': 82400000,  'type': 'gpos50'  },
      { 'id': 'q21.22', 'start': 82400001,  'end': 84100000,  'type': 'gneg'    },
      { 'id': 'q21.23', 'start': 84100001,  'end': 86900000,  'type': 'gpos25'  },
      { 'id': 'q21.3',  'start': 86900001,  'end': 88000000,  'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 88000001,  'end': 93700000,  'type': 'gpos75'  },
      { 'id': 'q22.2',  'start': 93700001,  'end': 95100000,  'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 95100001,  'end': 98800000,  'type': 'gpos75'  },
      { 'id': 'q23',    'start': 98800001,  'end': 101100000, 'type': 'gneg'    },
      { 'id': 'q24',    'start': 101100001, 'end': 107700000, 'type': 'gpos50'  },
      { 'id': 'q25',    'start': 107700001, 'end': 114100000, 'type': 'gneg'    },
      { 'id': 'q26',    'start': 114100001, 'end': 120800000, 'type': 'gpos75'  },
      { 'id': 'q27',    'start': 120800001, 'end': 123800000, 'type': 'gneg'    },
      { 'id': 'q28.1',  'start': 123800001, 'end': 128800000, 'type': 'gpos50'  },
      { 'id': 'q28.2',  'start': 128800001, 'end': 131100000, 'type': 'gneg'    },
      { 'id': 'q28.3',  'start': 131100001, 'end': 139500000, 'type': 'gpos100' },
      { 'id': 'q31.1',  'start': 139500001, 'end': 141500000, 'type': 'gneg'    },
      { 'id': 'q31.21', 'start': 141500001, 'end': 146800000, 'type': 'gpos25'  },
      { 'id': 'q31.22', 'start': 146800001, 'end': 148500000, 'type': 'gneg'    },
      { 'id': 'q31.23', 'start': 148500001, 'end': 151100000, 'type': 'gpos25'  },
      { 'id': 'q31.3',  'start': 151100001, 'end': 155600000, 'type': 'gneg'    },
      { 'id': 'q32.1',  'start': 155600001, 'end': 161800000, 'type': 'gpos100' },
      { 'id': 'q32.2',  'start': 161800001, 'end': 164500000, 'type': 'gneg'    },
      { 'id': 'q32.3',  'start': 164500001, 'end': 170100000, 'type': 'gpos100' },
      { 'id': 'q33',    'start': 170100001, 'end': 171900000, 'type': 'gneg'    },
      { 'id': 'q34.1',  'start': 171900001, 'end': 176300000, 'type': 'gpos75'  },
      { 'id': 'q34.2',  'start': 176300001, 'end': 177500000, 'type': 'gneg'    },
      { 'id': 'q34.3',  'start': 177500001, 'end': 183200000, 'type': 'gpos100' },
      { 'id': 'q35.1',  'start': 183200001, 'end': 187100000, 'type': 'gneg'    },
      { 'id': 'q35.2',  'start': 187100001, 'end': 191154276, 'type': 'gpos25'  },
    ],
  },
  '5': {
    'size'  : 180915260,
    'bands' : [
      { 'id': 'p11',    'start': 46100001,  'end': 48400000,  'type': 'acen'    },
      { 'id': 'p12',    'start': 42500001,  'end': 46100000,  'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 38400001,  'end': 42500000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 33800001,  'end': 38400000,  'type': 'gpos25'  },
      { 'id': 'p13.3',  'start': 28900001,  'end': 33800000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 24600001,  'end': 28900000,  'type': 'gpos100' },
      { 'id': 'p14.2',  'start': 23300001,  'end': 24600000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 18400001,  'end': 23300000,  'type': 'gpos100' },
      { 'id': 'p15.1',  'start': 15000001,  'end': 18400000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 9800001,   'end': 15000000,  'type': 'gpos50'  },
      { 'id': 'p15.31', 'start': 6300001,   'end': 9800000,   'type': 'gneg'    },
      { 'id': 'p15.32', 'start': 4500001,   'end': 6300000,   'type': 'gpos25'  },
      { 'id': 'p15.33', 'start': 1,         'end': 4500000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 48400001,  'end': 50700000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 50700001,  'end': 58900000,  'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 58900001,  'end': 62900000,  'type': 'gpos75'  },
      { 'id': 'q12.2',  'start': 62900001,  'end': 63200000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 63200001,  'end': 66700000,  'type': 'gpos75'  },
      { 'id': 'q13.1',  'start': 66700001,  'end': 68400000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 68400001,  'end': 73300000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 73300001,  'end': 76900000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 76900001,  'end': 81400000,  'type': 'gpos50'  },
      { 'id': 'q14.2',  'start': 81400001,  'end': 82800000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 82800001,  'end': 92300000,  'type': 'gpos100' },
      { 'id': 'q15',    'start': 92300001,  'end': 98200000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 98200001,  'end': 102800000, 'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 102800001, 'end': 104500000, 'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 104500001, 'end': 109600000, 'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 109600001, 'end': 111500000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 111500001, 'end': 113100000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 113100001, 'end': 115200000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 115200001, 'end': 121400000, 'type': 'gpos100' },
      { 'id': 'q23.2',  'start': 121400001, 'end': 127300000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 127300001, 'end': 130600000, 'type': 'gpos100' },
      { 'id': 'q31.1',  'start': 130600001, 'end': 136200000, 'type': 'gneg'    },
      { 'id': 'q31.2',  'start': 136200001, 'end': 139500000, 'type': 'gpos25'  },
      { 'id': 'q31.3',  'start': 139500001, 'end': 144500000, 'type': 'gneg'    },
      { 'id': 'q32',    'start': 144500001, 'end': 149800000, 'type': 'gpos75'  },
      { 'id': 'q33.1',  'start': 149800001, 'end': 152700000, 'type': 'gneg'    },
      { 'id': 'q33.2',  'start': 152700001, 'end': 155700000, 'type': 'gpos50'  },
      { 'id': 'q33.3',  'start': 155700001, 'end': 159900000, 'type': 'gneg'    },
      { 'id': 'q34',    'start': 159900001, 'end': 168500000, 'type': 'gpos100' },
      { 'id': 'q35.1',  'start': 168500001, 'end': 172800000, 'type': 'gneg'    },
      { 'id': 'q35.2',  'start': 172800001, 'end': 176600000, 'type': 'gpos25'  },
      { 'id': 'q35.3',  'start': 176600001, 'end': 180915260, 'type': 'gneg'    },
    ],
  },
  '6': {
    'size'  : 171115067,
    'bands' : [
      { 'id': 'p11.1',  'start': 58700001,  'end': 61000000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 57000001,  'end': 58700000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 52900001,  'end': 57000000,  'type': 'gpos100' },
      { 'id': 'p12.2',  'start': 51800001,  'end': 52900000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 46200001,  'end': 51800000,  'type': 'gpos100' },
      { 'id': 'p21.1',  'start': 40500001,  'end': 46200000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 36600001,  'end': 40500000,  'type': 'gpos25'  },
      { 'id': 'p21.31', 'start': 33500001,  'end': 36600000,  'type': 'gneg'    },
      { 'id': 'p21.32', 'start': 32100001,  'end': 33500000,  'type': 'gpos25'  },
      { 'id': 'p21.33', 'start': 30400001,  'end': 32100000,  'type': 'gneg'    },
      { 'id': 'p22.1',  'start': 27000001,  'end': 30400000,  'type': 'gpos50'  },
      { 'id': 'p22.2',  'start': 25200001,  'end': 27000000,  'type': 'gneg'    },
      { 'id': 'p22.3',  'start': 15200001,  'end': 25200000,  'type': 'gpos75'  },
      { 'id': 'p23',    'start': 13400001,  'end': 15200000,  'type': 'gneg'    },
      { 'id': 'p24.1',  'start': 11600001,  'end': 13400000,  'type': 'gpos25'  },
      { 'id': 'p24.2',  'start': 10600001,  'end': 11600000,  'type': 'gneg'    },
      { 'id': 'p24.3',  'start': 7100001,   'end': 10600000,  'type': 'gpos50'  },
      { 'id': 'p25.1',  'start': 4200001,   'end': 7100000,   'type': 'gneg'    },
      { 'id': 'p25.2',  'start': 2300001,   'end': 4200000,   'type': 'gpos25'  },
      { 'id': 'p25.3',  'start': 1,         'end': 2300000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 61000001,  'end': 63300000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 63300001,  'end': 63400000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 63400001,  'end': 70000000,  'type': 'gpos100' },
      { 'id': 'q13',    'start': 70000001,  'end': 75900000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 75900001,  'end': 83900000,  'type': 'gpos50'  },
      { 'id': 'q14.2',  'start': 83900001,  'end': 84900000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 84900001,  'end': 88000000,  'type': 'gpos50'  },
      { 'id': 'q15',    'start': 88000001,  'end': 93100000,  'type': 'gneg'    },
      { 'id': 'q16.1',  'start': 93100001,  'end': 99500000,  'type': 'gpos100' },
      { 'id': 'q16.2',  'start': 99500001,  'end': 100600000, 'type': 'gneg'    },
      { 'id': 'q16.3',  'start': 100600001, 'end': 105500000, 'type': 'gpos100' },
      { 'id': 'q21',    'start': 105500001, 'end': 114600000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 114600001, 'end': 118300000, 'type': 'gpos75'  },
      { 'id': 'q22.2',  'start': 118300001, 'end': 118500000, 'type': 'gneg'    },
      { 'id': 'q22.31', 'start': 118500001, 'end': 126100000, 'type': 'gpos100' },
      { 'id': 'q22.32', 'start': 126100001, 'end': 127100000, 'type': 'gneg'    },
      { 'id': 'q22.33', 'start': 127100001, 'end': 130300000, 'type': 'gpos75'  },
      { 'id': 'q23.1',  'start': 130300001, 'end': 131200000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 131200001, 'end': 135200000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 135200001, 'end': 139000000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 139000001, 'end': 142800000, 'type': 'gpos75'  },
      { 'id': 'q24.2',  'start': 142800001, 'end': 145600000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 145600001, 'end': 149000000, 'type': 'gpos75'  },
      { 'id': 'q25.1',  'start': 149000001, 'end': 152500000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 152500001, 'end': 155500000, 'type': 'gpos50'  },
      { 'id': 'q25.3',  'start': 155500001, 'end': 161000000, 'type': 'gneg'    },
      { 'id': 'q26',    'start': 161000001, 'end': 164500000, 'type': 'gpos50'  },
      { 'id': 'q27',    'start': 164500001, 'end': 171115067, 'type': 'gneg'    },
    ],
  },
  '7': {
    'size'  : 159138663,
    'bands' : [
      { 'id': 'p11.1',  'start': 58000001,  'end': 59900000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 54000001,  'end': 58000000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 50500001,  'end': 54000000,  'type': 'gpos75'  },
      { 'id': 'p12.2',  'start': 49000001,  'end': 50500000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 45400001,  'end': 49000000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 43300001,  'end': 45400000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 37200001,  'end': 43300000,  'type': 'gpos75'  },
      { 'id': 'p14.2',  'start': 35000001,  'end': 37200000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 28800001,  'end': 35000000,  'type': 'gpos75'  },
      { 'id': 'p15.1',  'start': 28000001,  'end': 28800000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 25500001,  'end': 28000000,  'type': 'gpos50'  },
      { 'id': 'p15.3',  'start': 20900001,  'end': 25500000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 16500001,  'end': 20900000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 13800001,  'end': 16500000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 7300001,   'end': 13800000,  'type': 'gpos100' },
      { 'id': 'p22.1',  'start': 4500001,   'end': 7300000,   'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 2800001,   'end': 4500000,   'type': 'gpos25'  },
      { 'id': 'p22.3',  'start': 1,         'end': 2800000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 59900001,  'end': 61700000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 61700001,  'end': 67000000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 67000001,  'end': 72200000,  'type': 'gpos50'  },
      { 'id': 'q11.23', 'start': 72200001,  'end': 77500000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 77500001,  'end': 86400000,  'type': 'gpos100' },
      { 'id': 'q21.12', 'start': 86400001,  'end': 88200000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 88200001,  'end': 91100000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 91100001,  'end': 92800000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 92800001,  'end': 98000000,  'type': 'gpos75'  },
      { 'id': 'q22.1',  'start': 98000001,  'end': 103800000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 103800001, 'end': 104500000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 104500001, 'end': 107400000, 'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 107400001, 'end': 114600000, 'type': 'gpos75'  },
      { 'id': 'q31.2',  'start': 114600001, 'end': 117400000, 'type': 'gneg'    },
      { 'id': 'q31.31', 'start': 117400001, 'end': 121100000, 'type': 'gpos75'  },
      { 'id': 'q31.32', 'start': 121100001, 'end': 123800000, 'type': 'gneg'    },
      { 'id': 'q31.33', 'start': 123800001, 'end': 127100000, 'type': 'gpos75'  },
      { 'id': 'q32.1',  'start': 127100001, 'end': 129200000, 'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 129200001, 'end': 130400000, 'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 130400001, 'end': 132600000, 'type': 'gneg'    },
      { 'id': 'q33',    'start': 132600001, 'end': 138200000, 'type': 'gpos50'  },
      { 'id': 'q34',    'start': 138200001, 'end': 143100000, 'type': 'gneg'    },
      { 'id': 'q35',    'start': 143100001, 'end': 147900000, 'type': 'gpos75'  },
      { 'id': 'q36.1',  'start': 147900001, 'end': 152600000, 'type': 'gneg'    },
      { 'id': 'q36.2',  'start': 152600001, 'end': 155100000, 'type': 'gpos25'  },
      { 'id': 'q36.3',  'start': 155100001, 'end': 159138663, 'type': 'gneg'    },
    ],
  },
  '8': {
    'size'  : 146364022,
    'bands' : [
      { 'id': 'p11.1',  'start': 43100001,  'end': 45600000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 39700001,  'end': 43100000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 38300001,  'end': 39700000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 36500001,  'end': 38300000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 28800001,  'end': 36500000,  'type': 'gpos75'  },
      { 'id': 'p21.1',  'start': 27400001,  'end': 28800000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 23300001,  'end': 27400000,  'type': 'gpos50'  },
      { 'id': 'p21.3',  'start': 19000001,  'end': 23300000,  'type': 'gneg'    },
      { 'id': 'p22',    'start': 12700001,  'end': 19000000,  'type': 'gpos100' },
      { 'id': 'p23.1',  'start': 6200001,   'end': 12700000,  'type': 'gneg'    },
      { 'id': 'p23.2',  'start': 2200001,   'end': 6200000,   'type': 'gpos75'  },
      { 'id': 'p23.3',  'start': 1,         'end': 2200000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 45600001,  'end': 48100000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 48100001,  'end': 52200000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 52200001,  'end': 52600000,  'type': 'gpos75'  },
      { 'id': 'q11.23', 'start': 52600001,  'end': 55500000,  'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 55500001,  'end': 61600000,  'type': 'gpos50'  },
      { 'id': 'q12.2',  'start': 61600001,  'end': 62200000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 62200001,  'end': 66000000,  'type': 'gpos50'  },
      { 'id': 'q13.1',  'start': 66000001,  'end': 68000000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 68000001,  'end': 70500000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 70500001,  'end': 73900000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 73900001,  'end': 78300000,  'type': 'gpos100' },
      { 'id': 'q21.12', 'start': 78300001,  'end': 80100000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 80100001,  'end': 84600000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 84600001,  'end': 86900000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 86900001,  'end': 93300000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 93300001,  'end': 99000000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 99000001,  'end': 101600000, 'type': 'gpos25'  },
      { 'id': 'q22.3',  'start': 101600001, 'end': 106200000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 106200001, 'end': 110500000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 110500001, 'end': 112100000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 112100001, 'end': 117700000, 'type': 'gpos100' },
      { 'id': 'q24.11', 'start': 117700001, 'end': 119200000, 'type': 'gneg'    },
      { 'id': 'q24.12', 'start': 119200001, 'end': 122500000, 'type': 'gpos50'  },
      { 'id': 'q24.13', 'start': 122500001, 'end': 127300000, 'type': 'gneg'    },
      { 'id': 'q24.21', 'start': 127300001, 'end': 131500000, 'type': 'gpos50'  },
      { 'id': 'q24.22', 'start': 131500001, 'end': 136400000, 'type': 'gneg'    },
      { 'id': 'q24.23', 'start': 136400001, 'end': 139900000, 'type': 'gpos75'  },
      { 'id': 'q24.3',  'start': 139900001, 'end': 146364022, 'type': 'gneg'    },
    ],
  },
  '9': {
    'size'  : 141213431,
    'bands' : [
      { 'id': 'p11.1',  'start': 47300001,  'end': 49000000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 43600001,  'end': 47300000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 41000001,  'end': 43600000,  'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 38400001,  'end': 41000000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 36300001,  'end': 38400000,  'type': 'gpos25'  },
      { 'id': 'p13.3',  'start': 33200001,  'end': 36300000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 28000001,  'end': 33200000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 25600001,  'end': 28000000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 19900001,  'end': 25600000,  'type': 'gpos100' },
      { 'id': 'p22.1',  'start': 18500001,  'end': 19900000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 16600001,  'end': 18500000,  'type': 'gpos25'  },
      { 'id': 'p22.3',  'start': 14200001,  'end': 16600000,  'type': 'gneg'    },
      { 'id': 'p23',    'start': 9000001,   'end': 14200000,  'type': 'gpos75'  },
      { 'id': 'p24.1',  'start': 4600001,   'end': 9000000,   'type': 'gneg'    },
      { 'id': 'p24.2',  'start': 2200001,   'end': 4600000,   'type': 'gpos25'  },
      { 'id': 'p24.3',  'start': 1,         'end': 2200000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 49000001,  'end': 50700000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 50700001,  'end': 65900000,  'type': 'gvar'    },
      { 'id': 'q13',    'start': 65900001,  'end': 68700000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 68700001,  'end': 72200000,  'type': 'gpos25'  },
      { 'id': 'q21.12', 'start': 72200001,  'end': 74000000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 74000001,  'end': 79200000,  'type': 'gpos50'  },
      { 'id': 'q21.2',  'start': 79200001,  'end': 81100000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 81100001,  'end': 84100000,  'type': 'gpos50'  },
      { 'id': 'q21.32', 'start': 84100001,  'end': 86900000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 86900001,  'end': 90400000,  'type': 'gpos50'  },
      { 'id': 'q22.1',  'start': 90400001,  'end': 91800000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 91800001,  'end': 93900000,  'type': 'gpos25'  },
      { 'id': 'q22.31', 'start': 93900001,  'end': 96600000,  'type': 'gneg'    },
      { 'id': 'q22.32', 'start': 96600001,  'end': 99300000,  'type': 'gpos25'  },
      { 'id': 'q22.33', 'start': 99300001,  'end': 102600000, 'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 102600001, 'end': 108200000, 'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 108200001, 'end': 111300000, 'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 111300001, 'end': 114900000, 'type': 'gpos25'  },
      { 'id': 'q32',    'start': 114900001, 'end': 117700000, 'type': 'gneg'    },
      { 'id': 'q33.1',  'start': 117700001, 'end': 122500000, 'type': 'gpos75'  },
      { 'id': 'q33.2',  'start': 122500001, 'end': 125800000, 'type': 'gneg'    },
      { 'id': 'q33.3',  'start': 125800001, 'end': 130300000, 'type': 'gpos25'  },
      { 'id': 'q34.11', 'start': 130300001, 'end': 133500000, 'type': 'gneg'    },
      { 'id': 'q34.12', 'start': 133500001, 'end': 134000000, 'type': 'gpos25'  },
      { 'id': 'q34.13', 'start': 134000001, 'end': 135900000, 'type': 'gneg'    },
      { 'id': 'q34.2',  'start': 135900001, 'end': 137400000, 'type': 'gpos25'  },
      { 'id': 'q34.3',  'start': 137400001, 'end': 141213431, 'type': 'gneg'    },
    ],
  },
  '10': {
    'size'  : 135534747,
    'bands' : [
      { 'id': 'p11.1',  'start': 38000001,  'end': 40200000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 34400001,  'end': 38000000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 31300001,  'end': 34400000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 29600001,  'end': 31300000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 24600001,  'end': 29600000,  'type': 'gpos50'  },
      { 'id': 'p12.2',  'start': 22600001,  'end': 24600000,  'type': 'gneg'    },
      { 'id': 'p12.31', 'start': 18700001,  'end': 22600000,  'type': 'gpos75'  },
      { 'id': 'p12.32', 'start': 18600001,  'end': 18700000,  'type': 'gneg'    },
      { 'id': 'p12.33', 'start': 17300001,  'end': 18600000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 12200001,  'end': 17300000,  'type': 'gneg'    },
      { 'id': 'p14',    'start': 6600001,   'end': 12200000,  'type': 'gpos75'  },
      { 'id': 'p15.1',  'start': 3800001,   'end': 6600000,   'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 3000001,   'end': 3800000,   'type': 'gpos25'  },
      { 'id': 'p15.3',  'start': 1,         'end': 3000000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 40200001,  'end': 42300000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 42300001,  'end': 46100000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 46100001,  'end': 49900000,  'type': 'gpos25'  },
      { 'id': 'q11.23', 'start': 49900001,  'end': 52900000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 52900001,  'end': 61200000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 61200001,  'end': 64500000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 64500001,  'end': 70600000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 70600001,  'end': 74900000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 74900001,  'end': 77700000,  'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 77700001,  'end': 82000000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 82000001,  'end': 87900000,  'type': 'gpos100' },
      { 'id': 'q23.2',  'start': 87900001,  'end': 89500000,  'type': 'gneg'    },
      { 'id': 'q23.31', 'start': 89500001,  'end': 92900000,  'type': 'gpos75'  },
      { 'id': 'q23.32', 'start': 92900001,  'end': 94100000,  'type': 'gneg'    },
      { 'id': 'q23.33', 'start': 94100001,  'end': 97000000,  'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 97000001,  'end': 99300000,  'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 99300001,  'end': 101900000, 'type': 'gpos50'  },
      { 'id': 'q24.31', 'start': 101900001, 'end': 103000000, 'type': 'gneg'    },
      { 'id': 'q24.32', 'start': 103000001, 'end': 104900000, 'type': 'gpos25'  },
      { 'id': 'q24.33', 'start': 104900001, 'end': 105800000, 'type': 'gneg'    },
      { 'id': 'q25.1',  'start': 105800001, 'end': 111900000, 'type': 'gpos100' },
      { 'id': 'q25.2',  'start': 111900001, 'end': 114900000, 'type': 'gneg'    },
      { 'id': 'q25.3',  'start': 114900001, 'end': 119100000, 'type': 'gpos75'  },
      { 'id': 'q26.11', 'start': 119100001, 'end': 121700000, 'type': 'gneg'    },
      { 'id': 'q26.12', 'start': 121700001, 'end': 123100000, 'type': 'gpos50'  },
      { 'id': 'q26.13', 'start': 123100001, 'end': 127500000, 'type': 'gneg'    },
      { 'id': 'q26.2',  'start': 127500001, 'end': 130600000, 'type': 'gpos50'  },
      { 'id': 'q26.3',  'start': 130600001, 'end': 135534747, 'type': 'gneg'    },
    ],
  },
  '11': {
    'size'  : 135006516,
    'bands' : [
      { 'id': 'p11.11', 'start': 51600001,  'end': 53700000,  'type': 'acen'    },
      { 'id': 'p11.12', 'start': 48800001,  'end': 51600000,  'type': 'gpos75'  },
      { 'id': 'p11.2',  'start': 43500001,  'end': 48800000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 36400001,  'end': 43500000,  'type': 'gpos100' },
      { 'id': 'p13',    'start': 31000001,  'end': 36400000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 27200001,  'end': 31000000,  'type': 'gpos75'  },
      { 'id': 'p14.2',  'start': 26100001,  'end': 27200000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 21700001,  'end': 26100000,  'type': 'gpos100' },
      { 'id': 'p15.1',  'start': 16200001,  'end': 21700000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 12700001,  'end': 16200000,  'type': 'gpos50'  },
      { 'id': 'p15.3',  'start': 10700001,  'end': 12700000,  'type': 'gneg'    },
      { 'id': 'p15.4',  'start': 2800001,   'end': 10700000,  'type': 'gpos50'  },
      { 'id': 'p15.5',  'start': 1,         'end': 2800000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 53700001,  'end': 55700000,  'type': 'acen'    },
      { 'id': 'q12.1',  'start': 55700001,  'end': 59900000,  'type': 'gpos75'  },
      { 'id': 'q12.2',  'start': 59900001,  'end': 61700000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 61700001,  'end': 63400000,  'type': 'gpos25'  },
      { 'id': 'q13.1',  'start': 63400001,  'end': 65900000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 65900001,  'end': 68400000,  'type': 'gpos25'  },
      { 'id': 'q13.3',  'start': 68400001,  'end': 70400000,  'type': 'gneg'    },
      { 'id': 'q13.4',  'start': 70400001,  'end': 75200000,  'type': 'gpos50'  },
      { 'id': 'q13.5',  'start': 75200001,  'end': 77100000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 77100001,  'end': 85600000,  'type': 'gpos100' },
      { 'id': 'q14.2',  'start': 85600001,  'end': 88300000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 88300001,  'end': 92800000,  'type': 'gpos100' },
      { 'id': 'q21',    'start': 92800001,  'end': 97200000,  'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 97200001,  'end': 102100000, 'type': 'gpos100' },
      { 'id': 'q22.2',  'start': 102100001, 'end': 102900000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 102900001, 'end': 110400000, 'type': 'gpos100' },
      { 'id': 'q23.1',  'start': 110400001, 'end': 112500000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 112500001, 'end': 114500000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 114500001, 'end': 121200000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 121200001, 'end': 123900000, 'type': 'gpos50'  },
      { 'id': 'q24.2',  'start': 123900001, 'end': 127800000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 127800001, 'end': 130800000, 'type': 'gpos50'  },
      { 'id': 'q25',    'start': 130800001, 'end': 135006516, 'type': 'gneg'    },
    ],
  },
  '12': {
    'size'  : 133851895,
    'bands' : [
      { 'id': 'p11.1',  'start': 33300001,  'end': 35800000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 30700001,  'end': 33300000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 27800001,  'end': 30700000,  'type': 'gpos50'  },
      { 'id': 'p11.23', 'start': 26500001,  'end': 27800000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 21300001,  'end': 26500000,  'type': 'gpos100' },
      { 'id': 'p12.2',  'start': 20000001,  'end': 21300000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 14800001,  'end': 20000000,  'type': 'gpos100' },
      { 'id': 'p13.1',  'start': 12800001,  'end': 14800000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 10100001,  'end': 12800000,  'type': 'gpos75'  },
      { 'id': 'p13.31', 'start': 5400001,   'end': 10100000,  'type': 'gneg'    },
      { 'id': 'p13.32', 'start': 3300001,   'end': 5400000,   'type': 'gpos25'  },
      { 'id': 'p13.33', 'start': 1,         'end': 3300000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 35800001,  'end': 38200000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 38200001,  'end': 46400000,  'type': 'gpos100' },
      { 'id': 'q13.11', 'start': 46400001,  'end': 49100000,  'type': 'gneg'    },
      { 'id': 'q13.12', 'start': 49100001,  'end': 51500000,  'type': 'gpos25'  },
      { 'id': 'q13.13', 'start': 51500001,  'end': 54900000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 54900001,  'end': 56600000,  'type': 'gpos25'  },
      { 'id': 'q13.3',  'start': 56600001,  'end': 58100000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 58100001,  'end': 63100000,  'type': 'gpos75'  },
      { 'id': 'q14.2',  'start': 63100001,  'end': 65100000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 65100001,  'end': 67700000,  'type': 'gpos50'  },
      { 'id': 'q15',    'start': 67700001,  'end': 71500000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 71500001,  'end': 75700000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 75700001,  'end': 80300000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 80300001,  'end': 86700000,  'type': 'gpos100' },
      { 'id': 'q21.32', 'start': 86700001,  'end': 89000000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 89000001,  'end': 92600000,  'type': 'gpos100' },
      { 'id': 'q22',    'start': 92600001,  'end': 96200000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 96200001,  'end': 101600000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 101600001, 'end': 103800000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 103800001, 'end': 109000000, 'type': 'gpos50'  },
      { 'id': 'q24.11', 'start': 109000001, 'end': 111700000, 'type': 'gneg'    },
      { 'id': 'q24.12', 'start': 111700001, 'end': 112300000, 'type': 'gpos25'  },
      { 'id': 'q24.13', 'start': 112300001, 'end': 114300000, 'type': 'gneg'    },
      { 'id': 'q24.21', 'start': 114300001, 'end': 116800000, 'type': 'gpos50'  },
      { 'id': 'q24.22', 'start': 116800001, 'end': 118100000, 'type': 'gneg'    },
      { 'id': 'q24.23', 'start': 118100001, 'end': 120700000, 'type': 'gpos50'  },
      { 'id': 'q24.31', 'start': 120700001, 'end': 125900000, 'type': 'gneg'    },
      { 'id': 'q24.32', 'start': 125900001, 'end': 129300000, 'type': 'gpos50'  },
      { 'id': 'q24.33', 'start': 129300001, 'end': 133851895, 'type': 'gneg'    },
    ],
  },
  '13': {
    'size'  : 115169878,
    'bands' : [
      { 'id': 'p11.1',  'start': 16300001,  'end': 17900000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 10000001,  'end': 16300000,  'type': 'gvar'    },
      { 'id': 'p12',    'start': 4500001,   'end': 10000000,  'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,         'end': 4500000,   'type': 'gvar'    },
      { 'id': 'q11',    'start': 17900001,  'end': 19500000,  'type': 'acen'    },
      { 'id': 'q12.11', 'start': 19500001,  'end': 23300000,  'type': 'gneg'    },
      { 'id': 'q12.12', 'start': 23300001,  'end': 25500000,  'type': 'gpos25'  },
      { 'id': 'q12.13', 'start': 25500001,  'end': 27800000,  'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 27800001,  'end': 28900000,  'type': 'gpos25'  },
      { 'id': 'q12.3',  'start': 28900001,  'end': 32200000,  'type': 'gneg'    },
      { 'id': 'q13.1',  'start': 32200001,  'end': 34000000,  'type': 'gpos50'  },
      { 'id': 'q13.2',  'start': 34000001,  'end': 35500000,  'type': 'gneg'    },
      { 'id': 'q13.3',  'start': 35500001,  'end': 40100000,  'type': 'gpos75'  },
      { 'id': 'q14.11', 'start': 40100001,  'end': 45200000,  'type': 'gneg'    },
      { 'id': 'q14.12', 'start': 45200001,  'end': 45800000,  'type': 'gpos25'  },
      { 'id': 'q14.13', 'start': 45800001,  'end': 47300000,  'type': 'gneg'    },
      { 'id': 'q14.2',  'start': 47300001,  'end': 50900000,  'type': 'gpos50'  },
      { 'id': 'q14.3',  'start': 50900001,  'end': 55300000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 55300001,  'end': 59600000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 59600001,  'end': 62300000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 62300001,  'end': 65700000,  'type': 'gpos75'  },
      { 'id': 'q21.32', 'start': 65700001,  'end': 68600000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 68600001,  'end': 73300000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 73300001,  'end': 75400000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 75400001,  'end': 77200000,  'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 77200001,  'end': 79000000,  'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 79000001,  'end': 87700000,  'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 87700001,  'end': 90000000,  'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 90000001,  'end': 95000000,  'type': 'gpos100' },
      { 'id': 'q32.1',  'start': 95000001,  'end': 98200000,  'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 98200001,  'end': 99300000,  'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 99300001,  'end': 101700000, 'type': 'gneg'    },
      { 'id': 'q33.1',  'start': 101700001, 'end': 104800000, 'type': 'gpos100' },
      { 'id': 'q33.2',  'start': 104800001, 'end': 107000000, 'type': 'gneg'    },
      { 'id': 'q33.3',  'start': 107000001, 'end': 110300000, 'type': 'gpos100' },
      { 'id': 'q34',    'start': 110300001, 'end': 115169878, 'type': 'gneg'    },
    ],
  },
  '14': {
    'size'  : 107349540,
    'bands' : [
      { 'id': 'p11.1',  'start': 16100001,  'end': 17600000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 8100001,   'end': 16100000,  'type': 'gvar'    },
      { 'id': 'p12',    'start': 3700001,   'end': 8100000,   'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,         'end': 3700000,   'type': 'gvar'    },
      { 'id': 'q11.1',  'start': 17600001,  'end': 19100000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 19100001,  'end': 24600000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 24600001,  'end': 33300000,  'type': 'gpos100' },
      { 'id': 'q13.1',  'start': 33300001,  'end': 35300000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 35300001,  'end': 36600000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 36600001,  'end': 37800000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 37800001,  'end': 43500000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 43500001,  'end': 47200000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 47200001,  'end': 50900000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 50900001,  'end': 54100000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 54100001,  'end': 55500000,  'type': 'gpos25'  },
      { 'id': 'q22.3',  'start': 55500001,  'end': 58100000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 58100001,  'end': 62100000,  'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 62100001,  'end': 64800000,  'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 64800001,  'end': 67900000,  'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 67900001,  'end': 70200000,  'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 70200001,  'end': 73800000,  'type': 'gpos50'  },
      { 'id': 'q24.3',  'start': 73800001,  'end': 79300000,  'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 79300001,  'end': 83600000,  'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 83600001,  'end': 84900000,  'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 84900001,  'end': 89800000,  'type': 'gpos100' },
      { 'id': 'q32.11', 'start': 89800001,  'end': 91900000,  'type': 'gneg'    },
      { 'id': 'q32.12', 'start': 91900001,  'end': 94700000,  'type': 'gpos25'  },
      { 'id': 'q32.13', 'start': 94700001,  'end': 96300000,  'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 96300001,  'end': 101400000, 'type': 'gpos50'  },
      { 'id': 'q32.31', 'start': 101400001, 'end': 103200000, 'type': 'gneg'    },
      { 'id': 'q32.32', 'start': 103200001, 'end': 104000000, 'type': 'gpos50'  },
      { 'id': 'q32.33', 'start': 104000001, 'end': 107349540, 'type': 'gneg'    },
    ],
  },
  '15': {
    'size'  : 102531392,
    'bands' : [
      { 'id': 'p11.1',  'start': 15800001, 'end': 19000000,  'type': 'acen'   },
      { 'id': 'p11.2',  'start': 8700001,  'end': 15800000,  'type': 'gvar'   },
      { 'id': 'p12',    'start': 3900001,  'end': 8700000,   'type': 'stalk'  },
      { 'id': 'p13',    'start': 1,        'end': 3900000,   'type': 'gvar'   },
      { 'id': 'q11.1',  'start': 19000001, 'end': 20700000,  'type': 'acen'   },
      { 'id': 'q11.2',  'start': 20700001, 'end': 25700000,  'type': 'gneg'   },
      { 'id': 'q12',    'start': 25700001, 'end': 28100000,  'type': 'gpos50' },
      { 'id': 'q13.1',  'start': 28100001, 'end': 30300000,  'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 30300001, 'end': 31200000,  'type': 'gpos50' },
      { 'id': 'q13.3',  'start': 31200001, 'end': 33600000,  'type': 'gneg'   },
      { 'id': 'q14',    'start': 33600001, 'end': 40100000,  'type': 'gpos75' },
      { 'id': 'q15.1',  'start': 40100001, 'end': 42800000,  'type': 'gneg'   },
      { 'id': 'q15.2',  'start': 42800001, 'end': 43600000,  'type': 'gpos25' },
      { 'id': 'q15.3',  'start': 43600001, 'end': 44800000,  'type': 'gneg'   },
      { 'id': 'q21.1',  'start': 44800001, 'end': 49500000,  'type': 'gpos75' },
      { 'id': 'q21.2',  'start': 49500001, 'end': 52900000,  'type': 'gneg'   },
      { 'id': 'q21.3',  'start': 52900001, 'end': 59100000,  'type': 'gpos75' },
      { 'id': 'q22.1',  'start': 59100001, 'end': 59300000,  'type': 'gneg'   },
      { 'id': 'q22.2',  'start': 59300001, 'end': 63700000,  'type': 'gpos25' },
      { 'id': 'q22.31', 'start': 63700001, 'end': 67200000,  'type': 'gneg'   },
      { 'id': 'q22.32', 'start': 67200001, 'end': 67300000,  'type': 'gpos25' },
      { 'id': 'q22.33', 'start': 67300001, 'end': 67500000,  'type': 'gneg'   },
      { 'id': 'q23',    'start': 67500001, 'end': 72700000,  'type': 'gpos25' },
      { 'id': 'q24.1',  'start': 72700001, 'end': 75200000,  'type': 'gneg'   },
      { 'id': 'q24.2',  'start': 75200001, 'end': 76600000,  'type': 'gpos25' },
      { 'id': 'q24.3',  'start': 76600001, 'end': 78300000,  'type': 'gneg'   },
      { 'id': 'q25.1',  'start': 78300001, 'end': 81700000,  'type': 'gpos50' },
      { 'id': 'q25.2',  'start': 81700001, 'end': 85200000,  'type': 'gneg'   },
      { 'id': 'q25.3',  'start': 85200001, 'end': 89100000,  'type': 'gpos50' },
      { 'id': 'q26.1',  'start': 89100001, 'end': 94300000,  'type': 'gneg'   },
      { 'id': 'q26.2',  'start': 94300001, 'end': 98500000,  'type': 'gpos50' },
      { 'id': 'q26.3',  'start': 98500001, 'end': 102531392, 'type': 'gneg'   },
    ],
  },
  '16': {
    'size'  : 90354753,
    'bands' : [
      { 'id': 'p11.1',  'start': 34600001, 'end': 36600000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 28100001, 'end': 34600000, 'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 24200001, 'end': 28100000, 'type': 'gpos50'  },
      { 'id': 'p12.2',  'start': 21200001, 'end': 24200000, 'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 16800001, 'end': 21200000, 'type': 'gpos50'  },
      { 'id': 'p13.11', 'start': 14800001, 'end': 16800000, 'type': 'gneg'    },
      { 'id': 'p13.12', 'start': 12600001, 'end': 14800000, 'type': 'gpos50'  },
      { 'id': 'p13.13', 'start': 10500001, 'end': 12600000, 'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 7900001,  'end': 10500000, 'type': 'gpos50'  },
      { 'id': 'p13.3',  'start': 1,        'end': 7900000,  'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 36600001, 'end': 38600000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 38600001, 'end': 47000000, 'type': 'gvar'    },
      { 'id': 'q12.1',  'start': 47000001, 'end': 52600000, 'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 52600001, 'end': 56700000, 'type': 'gpos50'  },
      { 'id': 'q13',    'start': 56700001, 'end': 57400000, 'type': 'gneg'    },
      { 'id': 'q21',    'start': 57400001, 'end': 66700000, 'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 66700001, 'end': 70800000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 70800001, 'end': 72900000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 72900001, 'end': 74100000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 74100001, 'end': 79200000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 79200001, 'end': 81700000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 81700001, 'end': 84200000, 'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 84200001, 'end': 87100000, 'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 87100001, 'end': 88700000, 'type': 'gpos25'  },
      { 'id': 'q24.3',  'start': 88700001, 'end': 90354753, 'type': 'gneg'    },
    ],
  },
  '17': {
    'size'  : 81195210,
    'bands' : [
      { 'id': 'p11.1',  'start': 22200001, 'end': 24000000, 'type': 'acen'   },
      { 'id': 'p11.2',  'start': 16000001, 'end': 22200000, 'type': 'gneg'   },
      { 'id': 'p12',    'start': 10700001, 'end': 16000000, 'type': 'gpos75' },
      { 'id': 'p13.1',  'start': 6500001,  'end': 10700000, 'type': 'gneg'   },
      { 'id': 'p13.2',  'start': 3300001,  'end': 6500000,  'type': 'gpos50' },
      { 'id': 'p13.3',  'start': 1,        'end': 3300000,  'type': 'gneg'   },
      { 'id': 'q11.1',  'start': 24000001, 'end': 25800000, 'type': 'acen'   },
      { 'id': 'q11.2',  'start': 25800001, 'end': 31800000, 'type': 'gneg'   },
      { 'id': 'q12',    'start': 31800001, 'end': 38100000, 'type': 'gpos50' },
      { 'id': 'q21.1',  'start': 38100001, 'end': 38400000, 'type': 'gneg'   },
      { 'id': 'q21.2',  'start': 38400001, 'end': 40900000, 'type': 'gpos25' },
      { 'id': 'q21.31', 'start': 40900001, 'end': 44900000, 'type': 'gneg'   },
      { 'id': 'q21.32', 'start': 44900001, 'end': 47400000, 'type': 'gpos25' },
      { 'id': 'q21.33', 'start': 47400001, 'end': 50200000, 'type': 'gneg'   },
      { 'id': 'q22',    'start': 50200001, 'end': 57600000, 'type': 'gpos75' },
      { 'id': 'q23.1',  'start': 57600001, 'end': 58300000, 'type': 'gneg'   },
      { 'id': 'q23.2',  'start': 58300001, 'end': 61100000, 'type': 'gpos75' },
      { 'id': 'q23.3',  'start': 61100001, 'end': 62600000, 'type': 'gneg'   },
      { 'id': 'q24.1',  'start': 62600001, 'end': 64200000, 'type': 'gpos50' },
      { 'id': 'q24.2',  'start': 64200001, 'end': 67100000, 'type': 'gneg'   },
      { 'id': 'q24.3',  'start': 67100001, 'end': 70900000, 'type': 'gpos75' },
      { 'id': 'q25.1',  'start': 70900001, 'end': 74800000, 'type': 'gneg'   },
      { 'id': 'q25.2',  'start': 74800001, 'end': 75300000, 'type': 'gpos25' },
      { 'id': 'q25.3',  'start': 75300001, 'end': 81195210, 'type': 'gneg'   },
    ],
  },
  '18': {
    'size'  : 78077248,
    'bands' : [
      { 'id': 'p11.1',  'start': 15400001, 'end': 17200000, 'type': 'acen'    },
      { 'id': 'p11.21', 'start': 10900001, 'end': 15400000, 'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 8500001,  'end': 10900000, 'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 7100001,  'end': 8500000,  'type': 'gneg'    },
      { 'id': 'p11.31', 'start': 2900001,  'end': 7100000,  'type': 'gpos50'  },
      { 'id': 'p11.32', 'start': 1,        'end': 2900000,  'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 17200001, 'end': 19000000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 19000001, 'end': 25000000, 'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 25000001, 'end': 32700000, 'type': 'gpos100' },
      { 'id': 'q12.2',  'start': 32700001, 'end': 37200000, 'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 37200001, 'end': 43500000, 'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 43500001, 'end': 48200000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 48200001, 'end': 53800000, 'type': 'gpos75'  },
      { 'id': 'q21.31', 'start': 53800001, 'end': 56200000, 'type': 'gneg'    },
      { 'id': 'q21.32', 'start': 56200001, 'end': 59000000, 'type': 'gpos50'  },
      { 'id': 'q21.33', 'start': 59000001, 'end': 61600000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 61600001, 'end': 66800000, 'type': 'gpos100' },
      { 'id': 'q22.2',  'start': 66800001, 'end': 68700000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 68700001, 'end': 73100000, 'type': 'gpos25'  },
      { 'id': 'q23',    'start': 73100001, 'end': 78077248, 'type': 'gneg'    },
    ],
  },
  '19': {
    'size'  : 59128983,
    'bands' : [
      { 'id': 'p11',    'start': 24400001, 'end': 26500000, 'type': 'acen'   },
      { 'id': 'p12',    'start': 20000001, 'end': 24400000, 'type': 'gvar'   },
      { 'id': 'p13.11', 'start': 16300001, 'end': 20000000, 'type': 'gneg'   },
      { 'id': 'p13.12', 'start': 14000001, 'end': 16300000, 'type': 'gpos25' },
      { 'id': 'p13.13', 'start': 13900001, 'end': 14000000, 'type': 'gneg'   },
      { 'id': 'p13.2',  'start': 6900001,  'end': 13900000, 'type': 'gpos25' },
      { 'id': 'p13.3',  'start': 1,        'end': 6900000,  'type': 'gneg'   },
      { 'id': 'q11',    'start': 26500001, 'end': 28600000, 'type': 'acen'   },
      { 'id': 'q12',    'start': 28600001, 'end': 32400000, 'type': 'gvar'   },
      { 'id': 'q13.11', 'start': 32400001, 'end': 35500000, 'type': 'gneg'   },
      { 'id': 'q13.12', 'start': 35500001, 'end': 38300000, 'type': 'gpos25' },
      { 'id': 'q13.13', 'start': 38300001, 'end': 38700000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 38700001, 'end': 43400000, 'type': 'gpos25' },
      { 'id': 'q13.31', 'start': 43400001, 'end': 45200000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 45200001, 'end': 48000000, 'type': 'gpos25' },
      { 'id': 'q13.33', 'start': 48000001, 'end': 51400000, 'type': 'gneg'   },
      { 'id': 'q13.41', 'start': 51400001, 'end': 53600000, 'type': 'gpos25' },
      { 'id': 'q13.42', 'start': 53600001, 'end': 56300000, 'type': 'gneg'   },
      { 'id': 'q13.43', 'start': 56300001, 'end': 59128983, 'type': 'gpos25' },
    ],
  },
  '20': {
    'size'  : 63025520,
    'bands' : [
      { 'id': 'p11.1',  'start': 25600001, 'end': 27500000, 'type': 'acen'   },
      { 'id': 'p11.21', 'start': 22300001, 'end': 25600000, 'type': 'gneg'   },
      { 'id': 'p11.22', 'start': 21300001, 'end': 22300000, 'type': 'gpos25' },
      { 'id': 'p11.23', 'start': 17900001, 'end': 21300000, 'type': 'gneg'   },
      { 'id': 'p12.1',  'start': 12100001, 'end': 17900000, 'type': 'gpos75' },
      { 'id': 'p12.2',  'start': 9200001,  'end': 12100000, 'type': 'gneg'   },
      { 'id': 'p12.3',  'start': 5100001,  'end': 9200000,  'type': 'gpos75' },
      { 'id': 'p13',    'start': 1,        'end': 5100000,  'type': 'gneg'   },
      { 'id': 'q11.1',  'start': 27500001, 'end': 29400000, 'type': 'acen'   },
      { 'id': 'q11.21', 'start': 29400001, 'end': 32100000, 'type': 'gneg'   },
      { 'id': 'q11.22', 'start': 32100001, 'end': 34400000, 'type': 'gpos25' },
      { 'id': 'q11.23', 'start': 34400001, 'end': 37600000, 'type': 'gneg'   },
      { 'id': 'q12',    'start': 37600001, 'end': 41700000, 'type': 'gpos75' },
      { 'id': 'q13.11', 'start': 41700001, 'end': 42100000, 'type': 'gneg'   },
      { 'id': 'q13.12', 'start': 42100001, 'end': 46400000, 'type': 'gpos25' },
      { 'id': 'q13.13', 'start': 46400001, 'end': 49800000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 49800001, 'end': 55000000, 'type': 'gpos75' },
      { 'id': 'q13.31', 'start': 55000001, 'end': 56500000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 56500001, 'end': 58400000, 'type': 'gpos50' },
      { 'id': 'q13.33', 'start': 58400001, 'end': 63025520, 'type': 'gneg'   },
    ],
  },
  '21': {
    'size'  : 48129895,
    'bands' : [
      { 'id': 'p11.1',  'start': 10900001, 'end': 13200000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 6800001,  'end': 10900000, 'type': 'gvar'    },
      { 'id': 'p12',    'start': 2800001,  'end': 6800000,  'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,        'end': 2800000,  'type': 'gvar'    },
      { 'id': 'q11.1',  'start': 13200001, 'end': 14300000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 14300001, 'end': 16400000, 'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 16400001, 'end': 24000000, 'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 24000001, 'end': 26800000, 'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 26800001, 'end': 31500000, 'type': 'gpos75'  },
      { 'id': 'q22.11', 'start': 31500001, 'end': 35800000, 'type': 'gneg'    },
      { 'id': 'q22.12', 'start': 35800001, 'end': 37800000, 'type': 'gpos50'  },
      { 'id': 'q22.13', 'start': 37800001, 'end': 39700000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 39700001, 'end': 42600000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 42600001, 'end': 48129895, 'type': 'gneg'    },
    ],
  },
  '22': {
    'size'  : 51304566,
    'bands' : [
      { 'id': 'p11.1',  'start': 12200001, 'end': 14700000, 'type': 'acen'   },
      { 'id': 'p11.2',  'start': 8300001,  'end': 12200000, 'type': 'gvar'   },
      { 'id': 'p12',    'start': 3800001,  'end': 8300000,  'type': 'stalk'  },
      { 'id': 'p13',    'start': 1,        'end': 3800000,  'type': 'gvar'   },
      { 'id': 'q11.1',  'start': 14700001, 'end': 17900000, 'type': 'acen'   },
      { 'id': 'q11.21', 'start': 17900001, 'end': 22200000, 'type': 'gneg'   },
      { 'id': 'q11.22', 'start': 22200001, 'end': 23500000, 'type': 'gpos25' },
      { 'id': 'q11.23', 'start': 23500001, 'end': 25900000, 'type': 'gneg'   },
      { 'id': 'q12.1',  'start': 25900001, 'end': 29600000, 'type': 'gpos50' },
      { 'id': 'q12.2',  'start': 29600001, 'end': 32200000, 'type': 'gneg'   },
      { 'id': 'q12.3',  'start': 32200001, 'end': 37600000, 'type': 'gpos50' },
      { 'id': 'q13.1',  'start': 37600001, 'end': 41000000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 41000001, 'end': 44200000, 'type': 'gpos50' },
      { 'id': 'q13.31', 'start': 44200001, 'end': 48400000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 48400001, 'end': 49400000, 'type': 'gpos50' },
      { 'id': 'q13.33', 'start': 49400001, 'end': 51304566, 'type': 'gneg'   },
    ],
  },
  'X': {
    'size'  : 155270560,
    'bands' : [
      { 'id': 'p11.1',  'start': 58100001,  'end': 60600000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 54800001,  'end': 58100000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 49800001,  'end': 54800000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 46400001,  'end': 49800000,  'type': 'gneg'    },
      { 'id': 'p11.3',  'start': 42400001,  'end': 46400000,  'type': 'gpos75'  },
      { 'id': 'p11.4',  'start': 37600001,  'end': 42400000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 31500001,  'end': 37600000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 29300001,  'end': 31500000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 24900001,  'end': 29300000,  'type': 'gpos100' },
      { 'id': 'p22.11', 'start': 21900001,  'end': 24900000,  'type': 'gneg'    },
      { 'id': 'p22.12', 'start': 19300001,  'end': 21900000,  'type': 'gpos50'  },
      { 'id': 'p22.13', 'start': 17100001,  'end': 19300000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 9500001,   'end': 17100000,  'type': 'gpos50'  },
      { 'id': 'p22.31', 'start': 6000001,   'end': 9500000,   'type': 'gneg'    },
      { 'id': 'p22.32', 'start': 4300001,   'end': 6000000,   'type': 'gpos50'  },
      { 'id': 'p22.33', 'start': 1,         'end': 4300000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 60600001,  'end': 63000000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 63000001,  'end': 64600000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 64600001,  'end': 67800000,  'type': 'gpos50'  },
      { 'id': 'q13.1',  'start': 67800001,  'end': 71800000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 71800001,  'end': 73900000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 73900001,  'end': 76000000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 76000001,  'end': 84600000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 84600001,  'end': 86200000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 86200001,  'end': 91800000,  'type': 'gpos100' },
      { 'id': 'q21.32', 'start': 91800001,  'end': 93500000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 93500001,  'end': 98300000,  'type': 'gpos75'  },
      { 'id': 'q22.1',  'start': 98300001,  'end': 102600000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 102600001, 'end': 103700000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 103700001, 'end': 108700000, 'type': 'gneg'    },
      { 'id': 'q23',    'start': 108700001, 'end': 116500000, 'type': 'gpos75'  },
      { 'id': 'q24',    'start': 116500001, 'end': 120900000, 'type': 'gneg'    },
      { 'id': 'q25',    'start': 120900001, 'end': 128700000, 'type': 'gpos100' },
      { 'id': 'q26.1',  'start': 128700001, 'end': 130400000, 'type': 'gneg'    },
      { 'id': 'q26.2',  'start': 130400001, 'end': 133600000, 'type': 'gpos25'  },
      { 'id': 'q26.3',  'start': 133600001, 'end': 138000000, 'type': 'gneg'    },
      { 'id': 'q27.1',  'start': 138000001, 'end': 140300000, 'type': 'gpos75'  },
      { 'id': 'q27.2',  'start': 140300001, 'end': 142100000, 'type': 'gneg'    },
      { 'id': 'q27.3',  'start': 142100001, 'end': 147100000, 'type': 'gpos100' },
      { 'id': 'q28',    'start': 147100001, 'end': 155270560, 'type': 'gneg'    },
    ],
  },
  'Y': {
    'size'  : 59373566,
    'bands' : [
      { 'id': 'p11.1',   'start': 11600001, 'end': 12500000, 'type': 'acen'   },
      { 'id': 'p11.2',   'start': 3000001,  'end': 11600000, 'type': 'gneg'   },
      { 'id': 'p11.31',  'start': 2500001,  'end': 3000000,  'type': 'gpos50' },
      { 'id': 'p11.32',  'start': 1,        'end': 2500000,  'type': 'gneg'   },
      { 'id': 'q11.1',   'start': 12500001, 'end': 13400000, 'type': 'acen'   },
      { 'id': 'q11.21',  'start': 13400001, 'end': 15100000, 'type': 'gneg'   },
      { 'id': 'q11.221', 'start': 15100001, 'end': 19800000, 'type': 'gpos50' },
      { 'id': 'q11.222', 'start': 19800001, 'end': 22100000, 'type': 'gneg'   },
      { 'id': 'q11.223', 'start': 22100001, 'end': 26200000, 'type': 'gpos50' },
      { 'id': 'q11.23',  'start': 26200001, 'end': 28800000, 'type': 'gneg'   },
      { 'id': 'q12',     'start': 28800001, 'end': 59373566, 'type': 'gvar'   },
    ],
  },
  'MT': {
    'size'  : 16569,
    'bands' : [
      { 'start': 1, 'end': 16569 },
    ],
  },
};
